var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SpFinder',{ref:"finder",attrs:{"id":"1","url":{
      data: _vm.requestUrl
    },"search":[{ key: 'searchname', name: '', slot: 'searchname' }],"hooks":{
      beforeSearch: _vm.beforeSearch
    },"title":"数据","show-tool-bar":false,"columns":_vm.columns,"actions":_vm.actions},on:{"reset":_vm.onFinderResetGroup},scopedSlots:_vm._u([{key:"searchname",fn:function(){return [_c('el-input',{attrs:{"placeholder":"请输入名称"},model:{value:(_vm.keyword),callback:function ($$v) {_vm.keyword=$$v},expression:"keyword"}})]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }